import React, {useRef} from 'react';
import { useReactToPrint } from 'react-to-print';
import { PrintSection } from './PrintSection';
import { Button } from '../../general/Button';
import { useTranslation } from 'react-i18next';

/* eslint import/no-webpack-loader-syntax: off */
import printcss from '!raw-loader!../../../styles/printstyle.css';

export const PrintButton: React.FC<{ buttonText: string; buttonClassName: string }> = ({
    buttonText,
    buttonClassName,
}) => {
    const { t } = useTranslation('pension');

    const contentRef = useRef<HTMLDivElement>(null);
    const handlePrint = useReactToPrint({
        contentRef: contentRef,
        documentTitle: t('pension-save-mybnd-modal-file-name'),
    });

    return (
        <div className={'flex flex-col items-center'}>
            <div>
                <Button onClick={() => handlePrint()} buttonType="primary" className={buttonClassName}>
                    {buttonText}
                </Button>
                <div className={'hidden'}>
                    <div ref={contentRef}>
                        {/* The style import is done because the print page can not find custom styling, since the print page has its own DOM.*/}
                        <style>{`@media print { ${printcss} }`}</style>
                        <PrintSection/>
                    </div>
                </div>
            </div>
        </div>
    );
};
